<script lang="ts" setup>
    import TheHeader from "~/components/layout/TheHeader.vue";

    const config = useGlobyConfig();

    useHead({
        link: [
            { rel: "icon", type: "image/png", href: "/img/favicon.png" },
        ],
    });
</script>

<template>
    <VApp>
        <TheHeader />
        <VMain>
            <nuxt-page />
        </VMain>
        <VFooter
            class="bg-brown-darken-1"
            padless
            style="border-top: yellow 5px solid"
        >
            <VContainer fluid>
                <VRow>
                    <VCol
                        align-self="center"
                        class="d-inline-flex justify-center"
                        cols="12"
                        sm="4"
                    >
                        <!--            <v-img :src="img('/img/logo_full.svg')" max-height="4rem"/>-->
                        <nuxt-img
                            alt="Logo van de vereniging. Gekenmerkt door het woord Logo Ipsum, 2 driehoeken en een lijn."
                            fit="cover"
                            src="/img/logo_full.png"
                            style="height: 6rem"
                        />
                    </VCol>

                    <VCol
                        align-self="center"
                        class="text-center"
                        cols="12"
                        sm="4"
                    >
                        Website door
                        <a href="mailto:contact@globy.app">Globy</a>
                        {{ new Date().getFullYear() }}
                    </VCol>
                    <VCol
                        align-self="center"
                        class="text-center"
                        cols="12"
                        sm="4"
                    >
                        Mail:
                        <a
                            :href="'mailto:' + config.organization.email.href"
                            class="text-white"
                            >{{ config.organization.email.text }}</a
                        >
                        <br />

                        Telefoon:
                        <a
                            :href="'tel:' + config.organization.telephone.href"
                            class="text-white"
                            >{{ config.organization.telephone.text }}</a
                        >
                        <br />
                        Privacy:
                        <router-link
                            class="text-white"
                            target="_blank"
                            to="/privacy"
                        >
                            klik hier
                        </router-link>
                        <br />
                        Algemene voorwaarden:
                        <router-link
                            class="text-white"
                            target="_blank"
                            to="/voorwaarden"
                        >
                            klik hier
                        </router-link>
                        <br />
                        KVK nummer: {{ config.organization.kvk_number }}
                        <br />
                        {{ config.organization.fullName }}
                    </VCol>
                </VRow>
            </VContainer>
        </VFooter>
    </VApp>
</template>

<style scoped></style>
